import { render } from "./seminar.vue?vue&type=template&id=0c4e9b26"
import script from "./seminar.vue?vue&type=script&lang=js"
export * from "./seminar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tavakolinejad-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__